// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".yaml-editor[data-v-c8a2f300]{flex:1;min-height:50vh;max-height:50vh}.yaml-editor[data-v-c8a2f300] .code-mirror .CodeMirror{position:static}.yaml-editor[data-v-c8a2f300] .code-mirror .CodeMirror,.yaml-editor[data-v-c8a2f300] .code-mirror .CodeMirror-gutters,.yaml-editor[data-v-c8a2f300] .code-mirror .CodeMirror-scroll{min-height:50vh;max-height:50vh}", ""]);
// Exports
module.exports = exports;
